import { useState } from 'react';

import {
  ActivityBuilderDrawerHeader,
  ActivityBuilderDrawerWrapper,
  ActivityBuilderDrawerContent,
} from 'approot/activity-builder/activity-builder-drawer';
import { useActivityBuilderContext } from 'approot/activity-builder/activity-builder.context';
import {
  SettingsGroup,
  SettingsLabel,
} from 'approot/activity-builder/settings/settings.style';
import ComponentImageField from '../shared/component-image-field/component-image-field';
import { FileDropperContextProvider } from 'lib/form/file-dropper/file-dropper.context';
import GifEditUpload from './gif-edit-upload';
import { EditProps } from './gif.constants';
import { useSimpleModalState } from 'approot/shared/modal/modal.hooks';
import GifEditModal from './gif-edit-modal';

const GifSettings = (props: EditProps) => {
  const [newFileProps, setNewFileProps] = useState<{
    key: string;
    fileName: string;
    file: File;
  }>();

  const { closeDrawer } = useActivityBuilderContext();
  const { isVisible, openModal, closeModal } = useSimpleModalState();

  return (
    <ActivityBuilderDrawerWrapper
      captureKeypresses={false}
      onCloseByEscape={closeDrawer}
    >
      {isVisible && (
        <GifEditModal
          {...props}
          fileToUpload={newFileProps}
          onClose={closeModal}
        />
      )}
      <ActivityBuilderDrawerHeader title="Animated GIF" onClose={closeDrawer} />
      <ActivityBuilderDrawerContent>
        <SettingsGroup>
          <SettingsLabel>GIF File</SettingsLabel>
          {props.properties?.image ? (
            <ComponentImageField
              image={props.properties.image}
              onEdit={openModal}
            />
          ) : (
            <FileDropperContextProvider>
              <GifEditUpload
                id={props.id}
                onShowModal={newFileProps => {
                  setNewFileProps(newFileProps);
                  openModal();
                }}
              />
            </FileDropperContextProvider>
          )}
        </SettingsGroup>
      </ActivityBuilderDrawerContent>
    </ActivityBuilderDrawerWrapper>
  );
};

export default GifSettings;
